import { Col, Form, Input, Modal, Row } from "antd";
import { FC, useState } from "react";
import { Address, CreateInput } from "src/lib/address-autocomplete";
import { IShippingAddress } from "types/address";
const InputThaiAddress = CreateInput();

interface IAddUserAddressModal {
  open: boolean;
  onOk: (formValue: IShippingAddress) => void;
  onCancel: () => void;
  isLoading?: boolean;
}
const AddUserAddressModal: FC<IAddUserAddressModal> = ({
  open,
  onOk,
  onCancel,
  isLoading,
}) => {
  const [address, setAddress] = useState<Address>({
    district: "", // ตำบล tambol
    amphoe: "", // อำเภอ amphoe
    province: "", // จังหวัด changwat
    zipcode: "", // รหัสไปรษณีย์ postal code
  });

  const [form] = Form.useForm();
  const handleChange = (scope: string) => (value: string) => {
    setAddress((oldAddr: Address) => ({
      ...oldAddr,
      [scope]: value,
    }));
  };

  const handleSelect = (address: Address) => {
    setAddress(address);
    form.setFieldsValue({
      province: address.province,
      district: address.amphoe,
      subdistrict: address.district,
      postCode: address.zipcode,
    });
  };

  return (
    <Modal
      open={open}
      onOk={() => onOk(form.getFieldsValue())}
      onCancel={onCancel}
      afterClose={() => {
        form.resetFields();
      }}
      cancelText="ยกเลิก"
      okText="บันทึก"
      width={550}
      confirmLoading={isLoading}
    >
      <Form form={form}>
        <Row>
          <Col span={6}>ชื่อผู้รับสินค้า :</Col>
          <Col span={16}>
            <Form.Item name="fullName" rules={[{ required: true }]}>
              <Input
                className="gray-input-border"
                placeholder="ชื่อ - นามสกุล"
              />
            </Form.Item>
          </Col>
          <Col span={6}>ชื่อ :</Col>
          <Col span={16}>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item name="type" rules={[{ required: true }]}>
                  <Input
                    className="gray-input-border"
                    placeholder="เช่น บ้านพ่อ โรงเรียน อื่นๆ"
                  />
                </Form.Item>
                <span className="text-gray-200 text-xs">
                  ตั้งชื่อที่อยู่ให้จำง่ายเวลาใช้ครั้งต่อไป
                </span>
              </Col>
            </Row>
          </Col>
          <Col span={6}>ที่อยู่ :</Col>
          <Col span={16}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item name="address" rules={[{ required: true }]}>
                  <Input
                    className="gray-input-border"
                    placeholder="บ้านเลขที่"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="building" rules={[{ required: true }]}>
                  <Input
                    className="gray-input-border"
                    placeholder="ชื่อสถานที่ / อาคาร"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={6} />
          <Col span={16}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item name="road">
                  <Input className="gray-input-border" placeholder="ถนน " />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="moo">
                  <Input className="gray-input-border" placeholder="หมู่" />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={6} />
          <Col span={16}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item name="postCode" rules={[{ required: true }]}>
                  <InputThaiAddress.Zipcode
                    value={address["zipcode"]}
                    onChange={handleChange("zipcode")}
                    onSelect={handleSelect}
                    autoCompleteProps={{
                      placeholder: "รหัสไปรษณีย์",
                      rootClassName: "address-autocomplete",
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="province" rules={[{ required: true }]}>
                  <InputThaiAddress.Province
                    value={address["province"]}
                    onChange={handleChange("province")}
                    onSelect={handleSelect}
                    autoCompleteProps={{
                      placeholder: "จังหวัด",
                      rootClassName: "address-autocomplete",
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={6} />
          <Col span={16}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item name="district" rules={[{ required: true }]}>
                  <InputThaiAddress.Amphoe
                    value={address["amphoe"]}
                    onChange={handleChange("amphoe")}
                    onSelect={handleSelect}
                    autoCompleteProps={{
                      placeholder: "อำเภอ / เขต",
                      rootClassName: "address-autocomplete",
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="subdistrict" rules={[{ required: true }]}>
                  <InputThaiAddress.District
                    value={address["district"]}
                    onChange={handleChange("district")}
                    onSelect={handleSelect}
                    autoCompleteProps={{
                      placeholder: "ตำบล",
                      rootClassName: "address-autocomplete",
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={6}>เบอร์โทรติดต่อ :</Col>
          <Col span={16}>
            <Form.Item name="phoneNumber" rules={[{ required: true }]}>
              <Input className="gray-input-border" placeholder="เบอร์โทร" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddUserAddressModal;
